import logo from "assets/images/logo-bianco.svg";
import VerticalStepper from "layout/components/vertical-stepper";

const SideBar: React.FC = () => {
	return (
		<div className="sidebar">
			<div>
				<div className="logo-container">
					<img alt="Logo" className="img-logo-small d-none d-md-block" src={logo} />
				</div>

				<VerticalStepper />
			</div>

			<LogoFooter />
		</div>
	);
};

const LogoFooter = () => {
	return (
		<div className="logo-container-footer">
			<span className="gray text-small m-0">POWERED BY</span>
			<div className="pt-2">
				<img alt="Logo buffetti finance" className="img-logo-medium d-none d-md-block" src={logo} />
			</div>
		</div>
	);
};

export default SideBar;
